jQuery(document).ready(function ($) {
  // Function to initialize the events slider
  var initEventsSlider = function ($block) {
    var $slider = $block.find(".slider-events");

    if ($slider.length) {
      $slider.on("init", function (event, slick) {
        $(".total-slides").text(slick.slideCount);
        $(".current-slide").text(slick.currentSlide + 1);
      });

      $slider.on("afterChange", function (event, slick, currentSlide) {
        $(".current-slide").text(currentSlide + 1);
      });

      $slider.slick({
        autoplay: false,
        dots: false,
      });

      // Slick measures container width on init and only recomputes on window resize.
      // Re-measure once lazy images / fonts settle, and on any container resize.
      var refresh = function () { $slider.slick("setPosition"); };
      $(window).on("load", refresh);
      if ("ResizeObserver" in window) {
        new ResizeObserver(refresh).observe($slider[0]);
      }
    }
  };

  // Init on the frontend
  $('.highlight-slider').each(function () {
    initEventsSlider($(this));
  });

  // Init in the backend
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=events', function( $block ) {
      initEventsSlider($block);
    });
  }
});